import messageTemplate from './components/message/message.html'

const templates = {
    message: messageTemplate,
}

const getTemplate = name => {
    return templates[name]
}

async function postJson(token, path, body) {
    return fetch('https://api.videokot.de.jeny-tech.ru/api' + path, {
        method: 'POST',
        headers: {
            'X-Parse-Application-Id': 'app',
            'X-Parse-REST-API-Key': 'rest_api_key8',
            'Content-Type': 'text/plain',
            //'Content-Type': 'application/json',
            'X-Parse-Session-Token': token
        },
        body: JSON.stringify(body),
    }).then(response => {
        /*if (response.statusText == 'Unauthorized') {
            throw new Error('Ошибка авторизации. Попробуйте выйти и зайти заного')
        }*/
        return response.json()
    })

    return res.content ? res.content.toJSON() : res
}
const getScreenWidth = _ => {
    if (!window.webkit) return window.screen.width

    return window._app.app.orientation == 'portrait' ? window.screen.width : window.screen.height
}

const getScreenHeight = _ => {
    if (!window.webkit) return window.screen.height

    return window._app.app.orientation == 'portrait' ? window.screen.height : window.screen.width
}

export { getTemplate, postJson, getScreenWidth, getScreenHeight }